import * as React from "react"

import { Layout } from "../../components/layout"
import Blog from "../../components/blog"

const Blogs = () => (
  <Layout>
    <div className="container">
       <Blog></Blog>
    </div>
  </Layout>
)

export default Blogs
